module.exports = __webpack_public_path__ + "media/images/bg-3458e45e653baa3fd586899997227f36.jpeg";